import { z } from "zod";
import {
  BrandSchema,
  createBrandSchema,
  updateBrandSchema,
  BrandStatusEnum,
} from "@/lib/validations/products/brand";

/** Fields that can be edited in a brand */
export type BrandEditableField = "name" | "description" | "website" | "logo";

/** Interface defining permissions for brand fields */
export interface BrandFieldPermissions {
  editable: BrandEditableField[];
  viewable: BrandEditableField[];
}

/** Fields that can be used for sorting brands */
export const BrandSortable = ["name", "created", "updated"] as const;
export type BrandSortField = (typeof BrandSortable)[number];

/** Status of a brand */
export type BrandStatus = z.infer<typeof BrandStatusEnum>;

/** Complete brand type with all fields */
export type Brand = z.infer<typeof BrandSchema>;

/** Type for creating a new brand */
export type CreateBrandInput = z.infer<typeof createBrandSchema>;

/** Type for updating an existing brand */
export type UpdateBrandInput = z.infer<typeof updateBrandSchema>;

/** Brand with relationships */
export interface BrandWithRelations extends Brand {
  products?: Array<{ id: string; name: string }>;
  companies?: Array<{ id: string; name: string }>;
}

/** Simplified brand type for lists */
export interface SimpleBrand {
  id: string;
  name: string;
  logo: string | null;
}
